module.exports = "<div>\r\n  <label>FOOTER</label>\r\n</div>\r\n"